import { ToggleButton, ToggleButtonGroup } from '@mui/material';

import type { SessionKind } from '../api/SessionKind';
import { useT } from '../i18n/LanguageContext';

/** Firma | Platforma — which API a public page talks to (ADR-0002). */
export const KindToggle = ({
  value,
  onChange,
}: {
  value: SessionKind;
  onChange: (next: SessionKind) => void;
}) => {
  const t = useT();

  return (
    <ToggleButtonGroup
      fullWidth
      exclusive
      size="small"
      value={value}
      onChange={(_event, next: SessionKind | null) => {
        if (next) onChange(next);
      }}
      sx={{ mb: 1.5 }}
    >
      <ToggleButton value="business">{t('login.kind.business')}</ToggleButton>
      <ToggleButton value="platform">{t('login.kind.platform')}</ToggleButton>
    </ToggleButtonGroup>
  );
};
